import type { ArticleData } from "../types/ArticleData";

import {ReactElement} from "react";

type Props = Readonly<{
    article: ArticleData;
    showCategories?: boolean;
    showAttributions?: boolean;
}>;

export default function WikiArticleDisplayPanel({article, showCategories = true, showAttributions = true}: Props): ReactElement {
    return (
        <>
            <h1 style={{ textAlign: "center" }}>{article.title}</h1>
            <hr />
            <div className="article-container">
                <div
                    className="article-content"
                    dangerouslySetInnerHTML={{
                        __html: article.text,
                    }}
                ></div>
                {showCategories && article.categories.length > 0 && (
                    <div
                        className="article-category-bar"
                        dangerouslySetInnerHTML={{
                            __html: `Categories: ${article.categories
                                .map(
                                    (category) =>
                                        `<a href="?category=${category}">${category}</a>`
                                )
                                .join(" | ")}`,
                        }}
                    ></div>
                )}
                {showAttributions && 
                    <div className="article-footer">
                        <div className="footer-left">
                            {article.creator == null
                                ? null
                                : `Creator: ${article.creator.name}`}
                        </div>
                        <div className="footer-right">
                            {article.editor == null
                                ? null
                                : `Last edit by: ${article.editor.name}`}
                        </div>
                    </div>
                }
            </div>
        </>
    );
}